<template>
    <div class="packeta">
        <p v-if="packeta">{{ packeta.place }}</p>
        <button type="button" class="primary-btn packeta-btn" @click="openPopup" :disabled="disableServiceButton(shipping)">
            {{ buttonText }}
        </button>
        <div class="form-group">
            <Field name="packeta" type="hidden" :rules="getRule()" v-model="packeta" />
            <ErrorMessage name="packeta" class="error-message" />
        </div>
    </div>
</template>
<script>
import { Field, ErrorMessage } from 'vee-validate';
import { mapGetters } from "vuex";
import useCart from "../../../views/cart/useCart";
import usePacketa from "./usePacketa"

export default {
    components: {
        Field,
        ErrorMessage,
    },
    props: {
        shipping: {
            type: Object
        }
    },
    computed: {
        ...mapGetters({
            packeta: 'packeta/getData'
        }),
    },
    methods: {
        getRule() {
            return !this.disableServiceButton(this.shipping) ? 'required' : ''
        },
        openPopup() {
            window.Packeta.Widget.pick(packetaApiKey, this.showSelectedPickupPoint)
        },
    },
    setup() {
        const {
            setCartLocalStorage
        } = useCart()
        const {
            disableServiceButton,
            showSelectedPickupPoint,
            buttonText
        } = usePacketa()

        return {
            buttonText,
            showSelectedPickupPoint,
            disableServiceButton,
            setCartLocalStorage,
        }
    }
}
</script>
<style lang="scss">
.packeta {
    margin: 15px 0 0 0;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -moz-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-direction: normal;
    -webkit-box-orient: horizontal;

    -webkit-align-items: center;
    -moz-align-items: center;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;

    -webkit-flex-wrap: wrap;
    -moz-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;

    p {
        margin: 10px 0 0 0;
    }

    .packeta-btn {
        margin: 0;
    }

    p {
        margin: 0 0 10px 0;
        -webkit-box-flex: 0;
        -webkit-flex: 0 0 100%;
        -moz-box-flex: 0;
        -moz-flex: 0 0 100%;
        -ms-flex: 0 0 100%;
        flex: 0 0 100%;
    }

    .error-message {
        position: static;
        margin: 0 0 0 20px;
    }
}

/* Main */
@media (max-width: 767px) {
    .packeta {
        .packeta-btn {
            font-size: 15px;
        }
    }
}
</style>
